
      var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMessageUsage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 12,
  r: 1,
  fill: "#000"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 1,
  fill: "#000"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 12,
  r: 1,
  fill: "#000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2.4v-.8.8Zm9.6 9.6h.8-.8ZM12 21.6v.8-.8Zm-3.969-.86.331-.728a.8.8 0 0 0-.58-.032l.25.76Zm-4.485.5-.058.798.058-.798Zm-.785-.785-.798.058.798-.058Zm.499-4.485.76.25a.8.8 0 0 0-.032-.581l-.728.33ZM2.4 12h-.8.8ZM12 2.4v.8a8.8 8.8 0 0 1 8.8 8.8h1.6c0-5.744-4.656-10.4-10.4-10.4v.8Zm9.6 9.6h-.8c0 4.86-3.94 8.8-8.8 8.8v1.6c5.744 0 10.4-4.656 10.4-10.4h-.8ZM12 21.6v-.8a8.762 8.762 0 0 1-3.638-.788l-.33.728-.332.728a10.36 10.36 0 0 0 4.3.933v-.8Zm-3.969-.86-.25-.76c-1.632.536-3.28.527-4.177.462l-.058.798-.058.798c.998.072 2.88.09 4.793-.538l-.25-.76Zm-4.485.5.058-.798a.063.063 0 0 1-.023-.005.034.034 0 0 1-.017-.017.065.065 0 0 1-.005-.023l-.798.058-.798.058a1.64 1.64 0 0 0 1.525 1.525l.058-.798Zm-.785-.785.798-.057c-.065-.898-.074-2.547.46-4.179l-.76-.25-.76-.249c-.627 1.912-.608 3.796-.536 4.793l.798-.058Zm.499-4.485.728-.332A8.763 8.763 0 0 1 3.2 12H1.6c0 1.534.335 2.99.932 4.301l.728-.331ZM2.4 12h.8A8.8 8.8 0 0 1 12 3.2V1.6C6.257 1.6 1.6 6.257 1.6 12h.8Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<circle cx=\"7\" cy=\"12\" r=\"1\" fill=\"black\"/>\r\n<circle cx=\"12\" cy=\"12\" r=\"1\" fill=\"black\"/>\r\n<circle cx=\"17\" cy=\"12\" r=\"1\" fill=\"black\"/>\r\n<path d=\"M12 2.40039V1.60039H12L12 2.40039ZM21.6006 12H22.4006V12L21.6006 12ZM12 21.6006L12 22.4006H12V21.6006ZM8.03125 20.7402L8.36249 20.012C8.1798 19.9289 7.97256 19.9175 7.78186 19.9801L8.03125 20.7402ZM3.5459 21.2402L3.48823 22.0382L3.48829 22.0382L3.5459 21.2402ZM2.76074 20.4551L1.96282 20.5127L1.96285 20.5131L2.76074 20.4551ZM3.25977 15.9697L4.01992 16.2191C4.08246 16.0284 4.07106 15.8212 3.98797 15.6385L3.25977 15.9697ZM2.40039 12L1.60039 12V12H2.40039ZM12 2.40039V3.20039C16.8601 3.20039 20.8004 7.14015 20.8006 12L21.6006 12L22.4006 12C22.4004 6.25634 17.7436 1.60039 12 1.60039V2.40039ZM21.6006 12H20.8006C20.8006 16.8601 16.8601 20.8006 12 20.8006V21.6006V22.4006C17.7438 22.4006 22.4006 17.7438 22.4006 12H21.6006ZM12 21.6006L12 20.8006C10.7021 20.8005 9.47184 20.5166 8.36249 20.012L8.03125 20.7402L7.70001 21.4684C9.01059 22.0646 10.4661 22.4005 12 22.4006L12 21.6006ZM8.03125 20.7402L7.78186 19.9801C6.14947 20.5157 4.50117 20.5071 3.60351 20.4423L3.5459 21.2402L3.48829 22.0382C4.48561 22.1102 6.36856 22.1277 8.28064 21.5004L8.03125 20.7402ZM3.5459 21.2402L3.60356 20.4423C3.59227 20.4415 3.58525 20.4391 3.58114 20.4372C3.57679 20.4352 3.57351 20.4328 3.57093 20.4302C3.56835 20.4276 3.5659 20.4243 3.56385 20.4198C3.56192 20.4156 3.55947 20.4085 3.55864 20.3971L2.76074 20.4551L1.96285 20.5131C2.02259 21.3348 2.66555 21.9787 3.48823 22.0382L3.5459 21.2402ZM2.76074 20.4551L3.55867 20.3975C3.49383 19.4995 3.48458 17.8511 4.01992 16.2191L3.25977 15.9697L2.49962 15.7204C1.87241 17.6325 1.89084 19.5158 1.96282 20.5127L2.76074 20.4551ZM3.25977 15.9697L3.98797 15.6385C3.48353 14.5295 3.20039 13.2985 3.20039 12H2.40039H1.60039C1.60039 13.5335 1.93522 14.9899 2.53156 16.301L3.25977 15.9697ZM2.40039 12L3.20039 12C3.20058 7.14021 7.14021 3.20058 12 3.20039L12 2.40039L12 1.60039C6.25654 1.60062 1.60062 6.25654 1.60039 12L2.40039 12Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/messageUsage.549d2266c53bad6c72b33c88a24848ec.svg"),
        {
          React: SvgMessageUsage,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      